import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'
import { Calculation } from 'final-form-calculate'
import { metaPath } from 'util/metaPath'

import { ConsultaSeguimentoFieldModel } from './model-consultaSeguimento'
import { ConsultaSeguimentoPergunta02Model } from './perguntas/consulta-seguimento-pergunta-02/model-consultaSeguimentoPergunta02'

const meta = metaPath<ConsultaSeguimentoFieldModel>()

export const consultaSeguimentoCalculator: Calculation[] = [
  {
    field: meta.aplicacao.PERGUNTA_02.PERGUNTA_02_FEZ_EXAME.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_02.PERGUNTA_02_RESULTADO_EXAME.absolutePath()]: (
        value: ConsultaSeguimentoPergunta02Model['PERGUNTA_02_FEZ_EXAME'],
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (value !== SimNaoEnum.SIM) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_02?.PERGUNTA_02_RESULTADO_EXAME
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_03.OUTRO.textValue.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_03.OUTRO.radioValue.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_03?.OUTRO?.radioValue
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_05.OUTRO.textValue.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_05.OUTRO.radioValue.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_05?.OUTRO?.radioValue
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_09.OUTRO.textValue.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_09.OUTRO.radioValue.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_09?.OUTRO?.radioValue
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_12.OUTRO.textValue.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_12.OUTRO.radioValue.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_12?.OUTRO?.radioValue
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_15.OUTRO.textValue.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_15.OUTRO.radioValue.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_15?.OUTRO?.radioValue
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_17.OUTRO.textValue.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_17.OUTRO.radioValue.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_17?.OUTRO?.radioValue
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_20.PERGUNTA_20_OUTRO.textValue.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_20.PERGUNTA_20_OUTRO.radioValue.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_20?.PERGUNTA_20_OUTRO?.radioValue
      },
    },
  },
]
